import {Component, Input, OnInit} from '@angular/core';
import {JSONCard} from "../CardStruct";
import {ActivatedRoute, Router} from "@angular/router";
import {eJSON_BRANCH_TYPE} from "../eBRANCH_TYPE";
import {VariableDataBase} from "../../variableDataBase/variable-data-base.service";

@Component({
  selector: 'app-card-department',
  templateUrl: './card-department.component.html',
  styleUrls: ['./card-department.component.css']
})
export class CardDepartmentComponent implements OnInit {
  @Input() card: JSONCard = new JSONCard();
  @Input() filelinkBack: number = 0;
  @Input() departmentClass: string = "json-department-card";

  readonly eJSON_BRANCH_TYPE: typeof eJSON_BRANCH_TYPE = eJSON_BRANCH_TYPE;

  constructor(
    private variableDataBase: VariableDataBase,
    private route: ActivatedRoute,
    private router: Router  ) {}

  ngOnInit(): void {

  }

  counter(i: number) {
    return new Array(i);
  }

  Home() {
    this.variableDataBase.Empty();
    this.router.navigate(['/cards', {filelink: 9999}]);
  }

  ZoomInCard(filelink: number) {
    console.log("ROUTING");
    this.variableDataBase.Empty();
    this.router.navigate(['/cards', { filelink: filelink }]);
  }

}
